import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const http = axios.create({ baseURL: `${BASE}/api/account`, withCredentials: true });

export const accountMe = () => http.get("/me").then((r) => r.data);
export const googleSession = (session_id) => http.post("/session", { session_id }).then((r) => r.data);
export const registerAccount = (body) => http.post("/register", body).then((r) => r.data);
export const loginAccount = (body) => http.post("/login", body).then((r) => r.data);
export const logoutAccount = () => http.post("/logout");
export const forgotPassword = (email) => http.post("/forgot-password", { email });
export const resetPassword = (token, password) => http.post("/reset-password", { token, password });
export const getAccountCycle = () => http.get("/cycle").then((r) => r.data);
export const putAccountCycle = (data) => http.put("/cycle", data);
export const putProfile = (patch) => http.put("/profile", patch).then((r) => r.data);
export const previewDailyEmail = (kind = "daily") => http.post(`/daily-email/preview?kind=${kind}`);
export const putFavorites = (favorites) => http.put("/favorites", { favorites }).then((r) => r.data);
export const dailyEmailOff = (token) => http.post("/daily-email/off", { token });

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleSignIn = () => {
  const redirectUrl = window.location.origin + "/";
  window.sessionStorage.setItem("lunelle-after-login", window.location.pathname + window.location.search);
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
